export const ContentWidth = {
  Fluid: 'fluid',
  Boxed: 'boxed',
} as const

export const NavbarType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const

export const FooterType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const

export const AppContentLayoutNav = {
  Vertical: 'vertical',
} as const
